export default {
    contentTitle: {
        guide: 'Activity Guide',
        guideTooltip: 'What is an Activity?',
    },
    modulePageTooltip: {
        tooltip: 'It\'s even better when done together!',
    },
    questionAccuracy: {
        realtime: 'Real-time',
        perQuestion: 'Per Question',
    },
};
